import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import defaultDressCodeImage from '../../../../images/default_dress_code.png';
import ActionsGroup from '../../../common/ui/ItemActions';
import Loader from '../../../common/ui/Loader';

export default class DressCode extends Component {
  static propTypes = {
    dress_code_id: PropTypes.number,
    dress_code: PropTypes.string,
    showEditIcons: PropTypes.bool.isRequired,
    dressCodesList: PropTypes.array.isRequired,
    getAllDressCodesAction: PropTypes.func.isRequired,
    editJob: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);
    const { dress_code_id, dress_code } = props;
    this.initialData = { dress_code_id, dress_code };
    this.state = {
      isLoading: false,
      isEditing: false,
      ...this.initialData
    };
  }

  componentDidMount () {
    this.props.getAllDressCodesAction();
  }

  startLoading = () => {
    this.setState({ isLoading: true });
  };

  startEditing = () => {
    this.setState({ isEditing: true });
  };

  cancelEditing = () => {
    this.setState({
      ...this.initialData,
      isEditing: false
    });
  };

  handleSelectDressCode = event => this.setState({ dress_code_id: parseInt(event.target.value, 10) });

  handleChangeInstructions = event => this.setState({ dress_code: event.target.value });

  submitEditing = e => {
    e.preventDefault();
    this.startLoading();
    const { dress_code_id, dress_code } = this.state;
    this.props.editJob({
      dress_code_id: dress_code_id || null,
      dress_code: dress_code_id && dress_code ? dress_code : null
    }).then(() => this.setState({ isEditing: false, isLoading: false }));
  };

  render () {
    const { isLoading, isEditing, dress_code_id, dress_code } = this.state;
    const { showEditIcons, dressCodesList } = this.props;
    const selectedDressCodeData = dressCodesList.find(dressCode => dressCode.id === dress_code_id);
    let dressCodeImgUrl = '';
    let dressCodeLabel = '';
    if (selectedDressCodeData) {
      dressCodeImgUrl = selectedDressCodeData.image_url;
      dressCodeLabel = selectedDressCodeData.description_en;
    }
    return (
      <section className='full-width'>
        <form onSubmit={this.submitEditing}>
          <div className='d-flex justify-content-between mb-2'>
            <h4 className='job-details-section-header'>Dress Code</h4>
            { showEditIcons && !isLoading && (
              <ActionsGroup
                isEditing={isEditing}
                enterEditMode={this.startEditing}
                exitEditMode={this.cancelEditing}
              />
            )}
          </div>
          { isLoading ? <div className='loader-wrapper'><Loader /></div> : (
            <Fragment>
              { dress_code_id || isEditing ? (
                <div className='dress-code-wrapper'>
                  <div
                    className='dress-code-img'
                    style={{ backgroundImage: `url('${dressCodeImgUrl || defaultDressCodeImage}')` }}
                  />
                  { isEditing ? (
                    <select
                      className='styled-select'
                      value={dress_code_id || ''}
                      name='dress_code_id'
                      onChange={this.handleSelectDressCode}
                    >
                      <option value='0'>No dress code</option>
                      {dressCodesList.map(dressCode =>
                        <option value={dressCode.id} key={dressCode.id}>
                          {dressCode.description_en}
                        </option>
                      )}
                    </select>
                  ) : (
                    <div className='styled-select'>{dressCodeLabel}</div>
                  )}
                  { ((!!dress_code && !isEditing) || (!!dress_code_id && isEditing)) && (
                    <div className='dress-code-description'>
                      <div className='dress-code-label'>Additional Dress Code Instructions:</div>
                      { isEditing ? (
                        <textarea
                          className='input input-textarea'
                          name='dress_code'
                          value={dress_code || ''}
                          placeholder='Type description here'
                          onChange={this.handleChangeInstructions}
                        />
                      ) : (
                        <p className='text'>{dress_code}</p>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <p>There is no dress code</p>
              )}
            </Fragment>
          )}
        </form>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/JobDetailsTab/DressCode.js